import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Spinner, Alert, Modal, Form } from 'react-bootstrap';
import { FaUsers, FaUserPlus, FaEye, FaCog, FaUserTimes, FaSave, FaTimes, FaExclamationTriangle, FaUserShield, FaCheckCircle, FaCheck, FaList, FaInfoCircle } from 'react-icons/fa';
import axios from 'axios';
import { authContext } from '../Context/AuthContext';
import { toast } from 'react-toastify';

// Configuración de API
const API_BASE_URL = process.env.REACT_APP_API_CLIENTE;

// CSS personalizado para z-index de toasts
const toastStyles = `
    .Toastify__toast-container {
        z-index: 9999 !important;
    }
`;

// Agregar estilos al head
if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.textContent = toastStyles;
    document.head.appendChild(styleElement);

    // Estilos para el fondo blurreado del modal
    if (!document.getElementById('modal-blur-style')) {
        const blurStyle = document.createElement('style');
        blurStyle.id = 'modal-blur-style';
        blurStyle.textContent = `
            .modal-blur-backdrop {
                background-color: rgba(30, 30, 30, 0.35) !important;
                backdrop-filter: blur(8px) !important;
                -webkit-backdrop-filter: blur(8px) !important;
            }
        `;
        document.head.appendChild(blurStyle);
    }
}



const PanelAdmin = () => {
    const { token, user } = useContext(authContext);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    // Estados para el modal de crear usuario
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showPermissionsModal, setShowPermissionsModal] = useState(false);
    const [creatingUser, setCreatingUser] = useState(false);
    const [assigningPermissions, setAssigningPermissions] = useState(false);
    const [newUserId, setNewUserId] = useState(null);
    const [currentStep, setCurrentStep] = useState(1); // Progreso de pasos
    
    // Estados para ver permisos de usuario
    const [showViewPermissionsModal, setShowViewPermissionsModal] = useState(false);
    const [selectedUserForPermissions, setSelectedUserForPermissions] = useState(null);
    const [userPermissions, setUserPermissions] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(false);
    
    const [formData, setFormData] = useState({
        Email: '',
        Nombre: '',
        Apellido: '',
        Sector: '',
        Administrador: false
    });

    // Permisos disponibles
    const availablePermissions = [
        { id: '001', name: 'Ver precios', description: 'Permite visualizar los precios de los productos' },
        { id: '002', name: 'Efectuar compras', description: 'Permite realizar pedidos y compras' },
        { id: '003', name: 'Estado de cuenta', description: 'Acceso al estado de cuenta y facturas' },
        { id: '004', name: 'Modificar datos de usuario', description: 'Permite editar información personal' },
        { id: '005', name: 'Deshabilitar usuario', description: 'Permite desactivar otros usuarios' },
        { id: '006', name: 'Ver historial de compra', description: 'Acceso al historial completo de compras' }
    ];

    const [selectedPermissions, setSelectedPermissions] = useState([]);
    // Estado para modal de confirmación de deshabilitar usuario
    const [showDisableModal, setShowDisableModal] = useState(false);
    const [userToDisable, setUserToDisable] = useState(null);

    // Función para abrir el modal de confirmación
    const handleOpenDisableModal = (usuario) => {
        setUserToDisable(usuario);
        setShowDisableModal(true);
    };

    // Función para cerrar el modal
    const handleCloseDisableModal = () => {
        setShowDisableModal(false);
        setUserToDisable(null);
    };

    // Función para deshabilitar usuario (líneas 98-118)
    const handleDisableUser = async () => {
        if (!userToDisable) return;
        try {
            console.log('Deshabilitando usuario:', userToDisable.UserId);
            console.log('URL:', `${API_BASE_URL}/users/${userToDisable.UserId}/disable`);
            
            const response = await axios.post(`${API_BASE_URL}/users/${userToDisable.UserId}/disable`, {
                deshabilitar: true  // <- AGREGAR ESTE CAMPO
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            console.log('Respuesta del servidor:', response.data);
            
            if (response.status === 200) {
                toast.success('Usuario deshabilitado correctamente');
                setShowDisableModal(false);
                setUserToDisable(null);
                
                // Actualizar la lista sin delay
                await fetchUsuarios();
            } else {
                toast.error('No se pudo deshabilitar el usuario');
            }
        } catch (error) {
            console.error('Error al deshabilitar usuario:', error);
            console.error('Error completo:', error.response?.data);
            
            if (error.response?.status === 404) {
                toast.error('Usuario no encontrado');
            } else if (error.response?.status === 401) {
                toast.error('No tienes permisos para deshabilitar usuarios');
            } else {
                toast.error(`Error al deshabilitar usuario: ${error.response?.data?.message || error.message}`);
            }
        }
    };

    // Componente de progreso de pasos
    const StepProgress = ({ currentStep }) => {
        const steps = [
            { number: 1, title: 'Términos', icon: FaExclamationTriangle },
            { number: 2, title: 'Datos', icon: FaUserPlus },
            { number: 3, title: 'Permisos', icon: FaUserShield }
        ];

        return (
            <div className="d-flex justify-content-center align-items-center mb-4 px-3">
                {steps.map((step, index) => {
                    const StepIcon = step.icon;
                    const isCompleted = currentStep > step.number;
                    const isCurrent = currentStep === step.number;
                    
                    return (
                        <React.Fragment key={step.number}>
                            <div className="text-center">
                                <div 
                                    className={`rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                                        isCompleted 
                                            ? 'bg-success text-white' 
                                            : isCurrent 
                                                ? 'bg-primary text-white' 
                                                : 'bg-light text-muted'
                                    }`}
                                    style={{ width: '50px', height: '50px' }}
                                >
                                    {isCompleted ? (
                                        <FaCheck size={20} />
                                    ) : (
                                        <StepIcon size={20} />
                                    )}
                                </div>
                                <div className={`small ${isCurrent ? 'text-primary fw-bold' : 'text-muted'}`}>
                                    Paso {step.number}
                                </div>
                                <div className={`small ${isCurrent ? 'text-primary fw-semibold' : 'text-muted'}`}>
                                    {step.title}
                                </div>
                            </div>
                            
                            {index < steps.length - 1 && (
                                <div 
                                    className={`flex-grow-1 mx-3 ${
                                        isCompleted ? 'border-success' : 'border-muted'
                                    }`}
                                    style={{ 
                                        height: '2px', 
                                        backgroundColor: isCompleted ? '#198754' : '#dee2e6',
                                        minWidth: '60px'
                                    }}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    // Función para obtener lista de usuarios
    const fetchUsuarios = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await axios.get(`${API_BASE_URL}/users`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                // La API devuelve {success: true, users: [...], count: n}
                const responseData = response.data;
                const userData = responseData.users || responseData;
                setUsuarios(Array.isArray(userData) ? userData : []);
            }
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
            setError('Error al cargar los usuarios');
            setUsuarios([]); // Asegurar que sea un array vacío en caso de error
            
            if (error.response?.status === 401) {
                toast.error('No tienes permisos para acceder a esta información');
            } else if (error.response?.status === 404) {
                toast.error('No se encontraron usuarios');
            } else {
                toast.error('Error al conectar con el servidor');
            }
        } finally {
            setLoading(false);
        }
    };

    // Función para crear nuevo usuario
    const createUser = async (userData) => {
        try {
            setCreatingUser(true);
            
            const response = await axios.post(`${API_BASE_URL}/users`, userData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200 || response.status === 201) {
                const newUser = response.data;
                console.log('Respuesta completa de creación de usuario:', newUser);
                
                // Intentar obtener el ID de diferentes formas posibles
                let userId = newUser.user?.UserId || newUser.UserId || newUser.id || newUser.user?.id;
                
                if (userId) {
                    setNewUserId(userId);
                    setCurrentStep(3);
                    setShowCreateModal(false);
                    setShowPermissionsModal(true);
                    toast.success('Usuario creado. Ahora asigna los permisos.');
                } else {
                    // Si no se puede obtener el ID inmediatamente, intentar buscarlo después de un delay
                    toast.info('Usuario creado, buscando ID...');
                    console.log('No se encontró ID inmediatamente, intentando después de delay...');
                    
                    // Esperar 2 segundos y buscar el usuario por email
                    setTimeout(async () => {
                        try {
                            const foundUserId = await findUserByEmail(userData.Email);
                            if (foundUserId) {
                                setNewUserId(foundUserId);
                                setCurrentStep(3);
                                setShowCreateModal(false);
                                setShowPermissionsModal(true);
                                toast.success('Usuario encontrado. Ahora asigna los permisos.');
                            } else {
                                toast.error('Usuario creado pero no se pudo encontrar para asignar permisos');
                                setShowCreateModal(false);
                                resetForm();
                                await fetchUsuarios();
                            }
                        } catch (error) {
                            console.error('Error buscando usuario:', error);
                            toast.error('Usuario creado pero ocurrió un error al buscar el ID');
                            setShowCreateModal(false);
                            resetForm();
                            await fetchUsuarios();
                        }
                    }, 2000);
                }
            }
        } catch (error) {
            console.error('Error al crear usuario:', error);
            
            if (error.response?.status === 400) {
                toast.error('Datos del usuario inválidos');
            } else if (error.response?.status === 401) {
                toast.error('No tienes permisos para crear usuarios');
            } else if (error.response?.status === 409) {
                toast.error('Ya existe un usuario con ese email');
            } else {
                toast.error('Error al crear el usuario');
            }
        } finally {
            setCreatingUser(false);
        }
    };

    // Función para buscar usuario por email (fallback para obtener ID)
    const findUserByEmail = async (email) => {
        try {
            // Recargar la lista de usuarios
            const response = await axios.get(`${API_BASE_URL}/users`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                const responseData = response.data;
                const userData = responseData.users || responseData;
                
                if (Array.isArray(userData)) {
                    const foundUser = userData.find(user => user.Email === email);
                    return foundUser?.UserId || null;
                }
            }
            return null;
        } catch (error) {
            console.error('Error buscando usuario por email:', error);
            return null;
        }
    };

    // Función para asignar permisos al usuario
    const assignPermissions = async (userId, permissions) => {
        try {
            setAssigningPermissions(true);
            
            const response = await axios.put(`${API_BASE_URL}/users/${userId}/permissions`, {
                permissions: permissions
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                toast.success('Permisos asignados exitosamente');
                setCurrentStep(1);
                setShowPermissionsModal(false);
                resetForm();
                resetPermissions();
                await fetchUsuarios(); // Recargar la lista
            }
        } catch (error) {
            console.error('Error al asignar permisos:', error);
            
            if (error.response?.status === 400) {
                toast.error('Datos de permisos inválidos');
            } else if (error.response?.status === 401) {
                toast.error('No tienes permisos para asignar permisos');
            } else if (error.response?.status === 404) {
                toast.error('Usuario no encontrado');
            } else {
                toast.error('Error al asignar permisos');
            }
        } finally {
            setAssigningPermissions(false);
        }
    };

    // Función para obtener permisos de un usuario específico
    const fetchUserPermissions = async (userId) => {
        try {
            setLoadingPermissions(true);
            
            const response = await axios.get(`${API_BASE_URL}/users/${userId}/permissions`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                const permissionsData = response.data;
                console.log('Permisos recibidos de la API:', permissionsData);
                
                // La API puede devolver un array directo o un objeto con permisos
                const permissions = permissionsData.permissions || permissionsData || [];
                console.log('Permisos procesados:', permissions);
                
                setUserPermissions(Array.isArray(permissions) ? permissions : []);
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error al obtener permisos del usuario:', error);
            
            if (error.response?.status === 401) {
                toast.error('No tienes permisos para ver esta información');
            } else if (error.response?.status === 404) {
                toast.error('Usuario no encontrado o sin permisos asignados');
                setUserPermissions([]); // Usuario sin permisos
                return true; // No es un error crítico
            } else {
                toast.error('Error al cargar permisos del usuario');
            }
            return false;
        } finally {
            setLoadingPermissions(false);
        }
    };

    // Función para abrir modal de ver permisos
    const handleViewPermissions = async (usuario) => {
        setSelectedUserForPermissions(usuario);
        setShowViewPermissionsModal(true);
        
        const success = await fetchUserPermissions(usuario.UserId);
        if (!success) {
            setShowViewPermissionsModal(false);
            setSelectedUserForPermissions(null);
        }
    };

    // Función para cerrar modal de ver permisos
    const handleCloseViewPermissionsModal = () => {
        setShowViewPermissionsModal(false);
        setSelectedUserForPermissions(null);
        setUserPermissions([]);
    };

    // Función para resetear permisos
    const resetPermissions = () => {
        setSelectedPermissions([]);
        setNewUserId(null);
    };

    // Función para resetear el formulario
    const resetForm = () => {
        setFormData({
            Email: '',
            Nombre: '',
            Apellido: '',
            Sector: '',
            Administrador: false // Siempre false, solo hay un admin
        });
    };

    // Función para manejar cambios en el formulario
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Función para manejar el submit del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validaciones básicas
        if (!formData.Email || !formData.Nombre || !formData.Apellido) {
            toast.error('Por favor completa todos los campos obligatorios');
            return;
        }

        // Validar email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.Email)) {
            toast.error('Por favor ingresa un email válido');
            return;
        }

        createUser(formData);
    };

    // Función para abrir modal de términos
    const handleOpenModal = () => {
        setCurrentStep(1);
        setShowTermsModal(true);
    };

    // Función para aceptar términos y abrir formulario
    const handleAcceptTerms = () => {
        setCurrentStep(2);
        setShowTermsModal(false);
        resetForm();
        setShowCreateModal(true);
    };

    // Función para rechazar términos
    const handleRejectTerms = () => {
        setCurrentStep(1);
        setShowTermsModal(false);
    };

    // Función para cerrar modal de formulario
    const handleCloseModal = () => {
        setCurrentStep(1);
        setShowCreateModal(false);
        resetForm();
    };

    // Función para cerrar modal de permisos
    const handleClosePermissionsModal = () => {
        setCurrentStep(1);
        setShowPermissionsModal(false);
        resetForm();
        resetPermissions();
    };

    // Función para manejar cambios en permisos
    const handlePermissionChange = (permissionId, checked) => {
        setSelectedPermissions(prev => {
            if (checked) {
                return [...prev, permissionId];
            } else {
                return prev.filter(id => id !== permissionId);
            }
        });
    };

    // Función para enviar permisos
    const handleSubmitPermissions = () => {
        if (selectedPermissions.length === 0) {
            toast.warning('Selecciona al menos un permiso para el usuario');
            return;
        }
        assignPermissions(newUserId, selectedPermissions);
    };

    // Cargar usuarios al montar el componente - solo una vez
    useEffect(() => {
        if (token) {
            fetchUsuarios();
        }
        // eslint-disable-next-line
    }, []); // Solo se ejecuta al montar, no cuando cambie el token

    // Función para obtener badge del estado (usando el campo Deshabilitado)
    const getStatusBadge = (deshabilitado) => {
        return !deshabilitado ? (
            <Badge bg="success">Activo</Badge>
        ) : (
            <Badge bg="danger">Inactivo</Badge>
        );
    };

    // Función para obtener badge del rol
    const getRoleBadge = (esAdmin) => {
        return esAdmin ? (
            <Badge bg="primary">Administrador</Badge>
        ) : (
            <Badge bg="secondary">Usuario</Badge>
        );
    };

    return (
        <Container fluid className="p-4">
            {/* Header */}
            <Row className="mb-4">
                <Col>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className="flex-grow-1">
                            <h4 className="mb-1 text-dark fw-semibold" style={{ fontSize: '1.35rem' }}>
                                <FaCog className="me-2 text-primary" style={{ fontSize: '1.2em', verticalAlign: 'middle' }} />
                                Administración de usuarios
                            </h4>
                            <p className="text-muted mb-0">
                                Gestión de usuarios para cliente n {user?.Cliente || 'Cliente'}
                            </p>
                        </div>
                        <div className="mt-2 mt-md-0" style={{ minWidth: 140 }}>
                            <Button 
                                variant="primary" 
                                size="lg"
                                className="w-100 w-md-auto"
                                disabled={loading}
                                onClick={handleOpenModal}
                            >
                                <FaUserPlus className="me-2 d-none d-md-inline" />
                                Crear Usuario
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Estadísticas */}
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="border-0 shadow-sm h-100">
                        <Card.Body className="text-center">
                            <div className="display-6 text-primary mb-2">
                                <FaUsers />
                            </div>
                            <h3 className="mb-1 text-dark">{Array.isArray(usuarios) ? usuarios.length : 0}</h3>
                            <p className="text-muted mb-0">Total Usuarios</p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="border-0 shadow-sm h-100">
                        <Card.Body className="text-center">
                            <div className="display-6 text-success mb-2">
                                <FaUsers />
                            </div>
                            <h3 className="mb-1 text-dark">
                                {Array.isArray(usuarios) ? usuarios.filter(u => !u.Deshabilitado).length : 0}
                            </h3>
                            <p className="text-muted mb-0">Usuarios Activos</p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="border-0 shadow-sm h-100">
                        <Card.Body className="text-center">
                            <div className="display-6 text-info mb-2">
                                <FaCog />
                            </div>
                            <h3 className="mb-1 text-dark">
                                {Array.isArray(usuarios) ? usuarios.filter(u => u.Administrador === true).length : 0}
                            </h3>
                            <p className="text-muted mb-0">Administradores</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Tabla de usuarios */}
            <Card className="border-0 shadow-sm">
                <Card.Header className="bg-light border-0">
                    <div className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-dark">
                            <FaUsers className="me-2" />
                            Lista de Usuarios
                        </h5>                     
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    {error && (
                        <Alert variant="danger" className="m-3 mb-0">
                            <strong>Error:</strong> {error}
                        </Alert>
                    )}
                    
                    {loading && (!Array.isArray(usuarios) || usuarios.length === 0) ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-3 text-muted">Cargando usuarios...</p>
                        </div>
                    ) : (!Array.isArray(usuarios) || usuarios.length === 0) ? (
                        <div className="text-center py-5">
                            <FaUsers className="display-1 text-muted mb-3" />
                            <h5 className="text-muted">No hay usuarios registrados</h5>
                            <p className="text-muted">Crea el primer usuario para comenzar</p>
                        </div>
                    ) : (
                        <>
                            {/* Desktop / tablet: tabla */}
                            <div className="d-none d-md-block">
                                <Table responsive hover className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="border-0">ID</th>
                                            <th className="border-0">Nombre Completo</th>
                                            <th className="border-0">Email</th>
                                            <th className="border-0">Rol</th>
                                            <th className="border-0">Estado</th>
                                            <th className="border-0 text-center">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(usuarios) && usuarios.map((usuario) => (
                                            <tr key={usuario.UserId}>
                                                <td className="fw-bold text-primary">#{usuario.UserId}</td>
                                                <td>
                                                    <div>
                                                        <div className="fw-semibold">{usuario.Nombre} {usuario.Apellido}</div>
                                                    </div>
                                                </td>
                                                <td className="text-muted">{usuario.Email}</td>
                                                <td>{getRoleBadge(usuario.Administrador)}</td>
                                                <td>{getStatusBadge(usuario.Deshabilitado)}</td>
                                                <td>
                                                    <div className="d-flex gap-1 justify-content-center">
                                                        <Button variant="outline-info" size="sm" title="Ver permisos" onClick={() => handleViewPermissions(usuario)}>
                                                            <FaEye />
                                                        </Button>
                                                        <Button variant="outline-danger" size="sm" title="Deshabilitar usuario" onClick={() => handleOpenDisableModal(usuario)}>
                                                            <FaUserTimes />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Mobile: tarjetas apiladas */}
                            <div className="d-block d-md-none p-2">
                                <Row className="g-2">
                                    {Array.isArray(usuarios) && usuarios.map((usuario) => (
                                        <Col xs={12} key={`m-${usuario.UserId}`}>
                                            <Card className="shadow-sm">
                                                <Card.Body className="p-3">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <div className="fw-bold text-primary">#{usuario.UserId} <span className="fw-semibold">{usuario.Nombre} {usuario.Apellido}</span></div>
                                                            <div className="text-muted small">{usuario.Email}</div>
                                                            <div className="mt-2">
                                                                {getRoleBadge(usuario.Administrador)} {' '}
                                                                {getStatusBadge(usuario.Deshabilitado)}
                                                            </div>
                                                        </div>
                                                        <div className="ms-2 text-end">
                                                            <div className="d-flex flex-column gap-2">
                                                                <Button variant="outline-info" size="sm" title="Ver permisos" onClick={() => handleViewPermissions(usuario)}>
                                                                    <FaEye />
                                                                </Button>
                                                                <Button variant="outline-danger" size="sm" title="Deshabilitar usuario" onClick={() => handleOpenDisableModal(usuario)}>
                                                                    <FaUserTimes />
                                                                </Button>
            {/* Modal de confirmación para deshabilitar usuario */}
            <Modal 
                show={showDisableModal} 
                onHide={handleCloseDisableModal}
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: 1060 }}
                backdropClassName="modal-blur-backdrop"
            >
                <Modal.Header className="bg-danger text-white">
                    <Modal.Title>
                        <FaUserTimes className="me-2" />
                        Confirmar deshabilitación
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {userToDisable && (
                        <div className="text-center">
                            <FaUserTimes className="display-1 text-danger mb-3" />
                            <h5 className="mb-3">¿Seguro que deseas deshabilitar este usuario?</h5>
                            <p className="lead text-muted mb-2">
                                <strong>{userToDisable.Nombre} {userToDisable.Apellido}</strong><br />
                                <span className="text-muted">Email: {userToDisable.Email}</span><br />
                                <span className="text-muted">ID: #{userToDisable.UserId}</span>
                            </p>
                            <p className="text-danger mb-0">Esta acción no se puede deshacer.</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleCloseDisableModal}
                        className="px-4"
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={handleDisableUser}
                        className="px-4"
                    >
                        Deshabilitar usuario
                    </Button>
                </Modal.Footer>
            </Modal>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </>
                    )}
                </Card.Body>
            </Card>

            {/* Modal de términos y condiciones */}
            <Modal 
                show={showTermsModal} 
                onHide={handleRejectTerms}
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: 1060 }}
            >
                <Modal.Header className="bg-warning text-dark">
                    <Modal.Title>
                        <FaExclamationTriangle className="me-2" />
                        Términos y Condiciones
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <StepProgress currentStep={currentStep} />
                    
                    <div className="text-center mb-4">
                        <FaExclamationTriangle className="display-1 text-warning mb-3" />
                        <h5 className="mb-3">Importante</h5>
                        <p className="lead text-muted">
                            Al crear un nuevo usuario, se aceptan automáticamente las 
                            <strong> bases y condiciones de usuario</strong> de la plataforma.
                        </p>
                        <p className="text-muted mb-0">
                            El usuario creado tendrá acceso a las funcionalidades según los 
                            permisos que se le asignen posteriormente.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleRejectTerms}
                        className="px-4"
                    >
                        <FaTimes className="me-2" />
                        Cancelar
                    </Button>
                    <Button 
                        variant="warning" 
                        onClick={handleAcceptTerms}
                        className="px-4"
                    >
                        <FaUserPlus className="me-2" />
                        Acepto y Continúo
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para crear usuario */}
            <Modal 
                show={showCreateModal} 
                onHide={handleCloseModal}
                size="lg"
                backdrop="static"
                keyboard={false}
                style={{ zIndex: 1060 }}
            >
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>
                        <FaUserPlus className="me-2" />
                        Crear Nuevo Usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <StepProgress currentStep={currentStep} />
                    
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Nombre <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="Nombre"
                                        value={formData.Nombre}
                                        onChange={handleInputChange}
                                        placeholder="Ingresa el nombre"
                                        required
                                        disabled={creatingUser}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Apellido <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="Apellido"
                                        value={formData.Apellido}
                                        onChange={handleInputChange}
                                        placeholder="Ingresa el apellido"
                                        required
                                        disabled={creatingUser}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">
                                Email <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="email"
                                name="Email"
                                value={formData.Email}
                                onChange={handleInputChange}
                                placeholder="usuario@empresa.com"
                                required
                                disabled={creatingUser}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Sector</Form.Label>
                            <Form.Select
                                name="Sector"
                                value={formData.Sector}
                                onChange={handleInputChange}
                                disabled={creatingUser}
                            >
                                <option value="">Selecciona un sector</option>
                                <option value="Compras">Compras</option>
                                <option value="Ventas">Ventas</option>
                                <option value="Administración">Administración</option>
                                <option value="IT">Tecnología</option>
                                <option value="Recursos Humanos">Recursos Humanos</option>
                                <option value="Contabilidad">Contabilidad</option>
                                <option value="Marketing">Marketing</option>
                                <option value="Operaciones">Operaciones</option>
                                <option value="Otro">Otro</option>
                            </Form.Select>
                        </Form.Group>

                        <hr />

                        <div className="d-flex justify-content-end gap-2">
                            <Button 
                                variant="outline-secondary" 
                                onClick={handleCloseModal}
                                disabled={creatingUser}
                            >
                                <FaTimes className="me-2" />
                                Cancelar
                            </Button>
                            <Button 
                                variant="primary" 
                                type="submit"
                                disabled={creatingUser}
                            >
                                {creatingUser ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Creando...
                                    </>
                                ) : (
                                    <>
                                        <FaSave className="me-2" />
                                        Crear Usuario
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal para asignar permisos */}
            <Modal 
                show={showPermissionsModal} 
                onHide={() => {}} // No se puede cerrar con ESC o backdrop
                size="lg"
                backdrop="static"
                keyboard={false}
                style={{ zIndex: 1060 }}
            >
                <Modal.Header className="bg-success text-white">
                    <Modal.Title>
                        <FaUserShield className="me-2" />
                        Asignar Permisos al Usuario #{newUserId}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <StepProgress currentStep={currentStep} />
                    
                    <div className="mb-4 text-center">
                        <h4 className="text-muted fw-bold mb-2">
                            <FaCheckCircle className="me-2 text-success" />
                            Usuario creado exitosamente.
                        </h4>
                        <p className="text-primary h6 mb-3 fw-semibold">
                            <FaUserShield className="me-2" />
                            <strong>Selecciona al menos un permiso</strong> para completar el registro:
                        </p>
                    </div>

                    <Row>
                        {availablePermissions
                            .filter(p => p.id !== '005' || user?.Administrador === true)
                            .map((permission) => {
                                const isSelected = selectedPermissions.includes(permission.id);
                                return (
                                    <Col md={6} key={permission.id} className="mb-3">
                                        <Card
                                            className={`border h-100 ${isSelected ? 'border-primary' : 'border-light'}`}
                                            style={isSelected ? { borderWidth: '2px', boxShadow: '0 0 0 .125rem rgba(13,110,253,0.12)', transition: 'border-color .18s, box-shadow .18s', cursor: assigningPermissions ? 'not-allowed' : 'pointer' } : { transition: 'border-color .18s, box-shadow .18s', cursor: assigningPermissions ? 'not-allowed' : 'pointer' }}
                                            onClick={() => !assigningPermissions && handlePermissionChange(permission.id, !isSelected)}
                                        >
                                            <Card.Body className="p-3">
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`permission-${permission.id}`}
                                                    label=""
                                                    checked={isSelected}
                                                    onChange={(e) => handlePermissionChange(permission.id, e.target.checked)}
                                                    disabled={assigningPermissions}
                                                    className="float-end"
                                                    onClick={e => e.stopPropagation()}
                                                />
                                                <div className="pe-4">
                                                    <h6 className="mb-1 text-primary">
                                                        {permission.id} - {permission.name}
                                                    </h6>
                                                    <p className="text-muted small mb-0">
                                                        {permission.description}
                                                    </p>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                    </Row>

                    <hr />

                    <div className="d-flex justify-content-center">
                        <Button 
                            variant="success" 
                            onClick={handleSubmitPermissions}
                            disabled={assigningPermissions || selectedPermissions.length === 0}
                            size="lg"
                            className="px-4"
                        >
                            {assigningPermissions ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Asignando permisos...
                                </>
                            ) : (
                                <>
                                    <FaUserShield className="me-2" />
                                    Asignar Permisos ({selectedPermissions.length})
                                </>
                            )}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal para ver permisos de usuario */}
            <Modal 
                show={showViewPermissionsModal} 
                onHide={handleCloseViewPermissionsModal}
                size="lg"
                centered
                style={{ zIndex: 1060 }}
            >
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>
                        <FaEye className="me-2" />
                        Permisos del Usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {selectedUserForPermissions && (
                        <div className="mb-4 text-center">
                            <div className="bg-light rounded p-3 mb-3">
                                <h5 className="mb-1 text-primary">
                                    {selectedUserForPermissions.Nombre} {selectedUserForPermissions.Apellido}
                                </h5>
                                <p className="text-muted mb-1">
                                    <strong>Email:</strong> {selectedUserForPermissions.Email}
                                </p>
                                <p className="text-muted mb-0">
                                    <strong>ID:</strong> #{selectedUserForPermissions.UserId}
                                </p>
                            </div>
                        </div>
                    )}

                    {loadingPermissions ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" variant="info" />
                            <p className="mt-3 text-muted">Cargando permisos...</p>
                        </div>
                    ) : userPermissions.length === 0 ? (
                        <div className="text-center py-4">
                            <FaInfoCircle className="display-3 text-muted mb-3" />
                            <h6 className="text-muted">Sin permisos asignados</h6>
                            <p className="text-muted">Este usuario no tiene permisos específicos asignados.</p>
                        </div>
                    ) : (
                        <div>
                            <h6 className="mb-3">
                                <FaList className="me-2 text-info" />
                                Permisos Asignados ({userPermissions.length}):
                            </h6>
                            
                            <Row>
                                {userPermissions.map((permission, index) => {
                                    // La API devuelve objetos con {Codigo, Descripcion}
                                    const permissionCode = permission.Descripcion || permission.Codigo || permission.codigo || permission.id || permission;
                                    // Buscar la información del permiso en availablePermissions por id
                                    const permissionInfo = availablePermissions.find(p => p.id === permissionCode);
                                    
                                    return (
                                        <Col md={6} key={index} className="mb-3">
                                            <Card className="border-info h-100">
                                                <Card.Body className="p-3">
                                                    <div className="d-flex align-items-start">
                                                        <div className="me-3">
                                                            <div 
                                                                className="rounded-circle bg-info text-white d-flex align-items-center justify-content-center"
                                                                style={{ width: '35px', height: '35px' }}
                                                            >
                                                                <FaCheck size={16} />
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1 text-info">
                                                                {permissionInfo ? `${permissionInfo.id} - ${permissionInfo.name}` : `Permiso ${permissionCode}`}
                                                            </h6>
                                                            <p className="text-muted small mb-0">
                                                                {permissionInfo ? permissionInfo.description : 'Descripción no disponible'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseViewPermissionsModal}>
                        <FaTimes className="me-2" />
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default PanelAdmin;